export const SEARCH_TYPE_ASK_AI = "ai_discoveries";
